module.exports = __webpack_public_path__ + "assets/error-white.3e85b7522af399638398b810e9c4799f.svg";